import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  Button,
  Card,
  InputNumber,
  Modal,
  Popover,
  Progress,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
  Divider,
  Select,
  Checkbox,
  Spin,
} from 'antd';
import KeyResult from './KeyResult';
import Objective from './Objective';
import {
  CaretDownOutlined,
  CaretRightOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LinkOutlined,
  PlusOutlined,
  CheckOutlined,
  ToTopOutlined,
  EditOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { NumberParam, QueryParams, StringParam, useQueryParams } from 'use-query-params';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import MarksPopOver from '../../../../components/molecules/MarksPopOver/MarksPopOver';
import KeyUpdateInput from '../../../../components/molecules/KeyUpdateInput/KeyUpdateInput';
import { isNaN } from 'lodash';
import Title from 'antd/lib/typography/Title';
const { Text, Link } = Typography;
const { confirm } = Modal;
const { Option } = Select;

const queryConfig = {
  parent: NumberParam,
};

export type GoalsPageForTeamProps = {
  setLoading1?: (x: boolean) => void;
  value: {
    total: number;
    goals: any[];
    parentTeams: number;
    approvalStatus: string;
    goalSummaryId: number;
    goalsAvailability: boolean;
    teamId?: number;
    teamName?: string;
    goalSummaryOwner?: number;
  };
  focus: boolean;
  currentCycleValue: number;
  performanceCycles: any[];
  reload: () => void;
  totalCyclePercentage?: number;
};

type WeightInputProps = {
  value: number;
  onChange: (e: number) => void;
  setLoading?: (x: boolean) => void;
};

const WeightInput: FC<WeightInputProps> = (props) => {
  const [value, setValue] = useState<number>(props.value);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const content = useMemo(
    () => (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Space size={40} style={{ display: 'flex', alignItems: 'baseline' }}>
          <Space style={{ marginBottom: 20 }}>
            <UserOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
            <Text type="secondary">Weight</Text>
          </Space>
          <>
            <InputNumber
              min={0}
              type={'number'}
              value={value ?? 0}
              style={{ width: 97 }}
              onChange={(e) => setValue(e ?? 0)}
            />
          </>
        </Space>
        <Button
          disabled={value === null || value === undefined}
          type="primary"
          onClick={() => {
            props.onChange(value);
            setIsVisible(false);
          }}>
          Update
        </Button>
      </div>
    ),
    [props, value],
  );
  return (
    <>
      <Popover
        onOpenChange={(v) => {
          if (v) {
            setIsVisible(true);
            // props.onSubmit?.();
          } else {
            setIsVisible(false);
            setValue(props.value);
          }
        }}
        open={isVisible}
        zIndex={2000}
        style={{ position: 'fixed', paddingRight: '10px' }}
        destroyTooltipOnHide
        content={content}
        trigger="click">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}>
          <Typography style={{ cursor: 'pointer' }}>
            {isNaN(props.value) ? 0 : props.value}
          </Typography>
          <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <EditOutlined />
          </div>
        </div>
      </Popover>
    </>
  );
};

export const GoalsPageForTeam: FC<GoalsPageForTeamProps> = (props) => {
  const [query, setQuery] = useQueryParams({
    goalId: NumberParam,
    keyResultId: NumberParam,
    newGoal: StringParam,
    cycle: NumberParam,
  });
  const [total, setTotal] = useState<number>(0);
  const [supervisors, setSupervisors] = useState<number[]>([]);
  const [directSupervisors, setDirectSupervisors] = useState<number[]>([]);
  const [objectiveError, setObjectiveError] = useState<{ error: string; isError: boolean }>();
  const [weightList, setWeightList] = useState<
    Record<
      number,
      {
        weight: number;
        onHold: boolean;
      }
    >
  >({});
  const [maxWeight, setMaxWeight] = useState<number>();
  const [data, setData] = useState<any[]>([]);
  const [mode, setMode] = useState<'view' | 'edit'>('view');
  const [goalSummaryId, setGoalSummaryId] = useState<number>(0);
  const [approvalStatus, setApprovalStatus] = useState<string>('');
  const [fetching, setFetching] = useState<boolean>(false);
  const [isSupervisor, setIsSupervisor] = useState<boolean>(false);
  const [popOverVisible, setPopOverVisible] = useState<string>('');
  const [popOverVisible1, setPopOverVisible1] = useState<string>('');
  const [popOverVisible2, setPopOverVisible2] = useState<string>('');
  const [popOverVisible3, setPopOverVisible3] = useState<string>('');
  const [isLeader, setIsLeader] = useState<boolean>(false);
  const [currentCycleValue, setCurrentCycleValue] = useState<number>(0);
  const [performanceCycles, setPerformanceCycles] = useState<any[]>([]);
  const params = useParams<{
    type: string;
    id: string;
    name: string;
    cycle: string;
    oid: string;
  }>();
  const location = useLocation();
  const connection = useConnection();
  const user = useUserInfo();
  const history1 = useHistory();
  const { focus } = props;
  const [totalSupVis, setTotalSupVis] = useState<number>(0);
  const [totalSelfUserMarks, setTotalSelfUserMarks] = useState<number>(0);
  const [supervisorEvaluationList, setSupervisorEvaluationList] = useState<
    Record<number, { supervisorMark: number; weight: number }>
  >({});
  const [selfEvaluationList, setSelfEvaluationList] = useState<
    Record<number, { selfUserMark: number; weight: number }>
  >({});
  const [isSelfUserMarks, setIsSelfUserMarks] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [loading1, setLoading1] = useState<boolean>(false);
  const [keyResultCount, setKeyResultCount] = useState<number>(1);
  const [expanded, setExpanded] = useState<boolean>(false);
  const [expandedRow, setExpandedRow] = useState<string[]>([]);
  const [commonObjectiveVisible, setCommonObjectiveVisible] = useState<boolean>(false);
  const [totalSelfPercent, setTotalSelfPercent] = useState<number>(0);
  const [totalSupVisPercent, setTotalSupVisPercent] = useState<number>(0);
  const [commonGoals, setCommonGoals] = useState<any[]>([]);
  const [selectCommonObjective, setSelectCommonObjective] = useState<number>();

  useEffect(() => {
    setPerformanceCycles(props.performanceCycles);
    setCurrentCycleValue(props.currentCycleValue);
  }, [props.currentCycleValue, props.performanceCycles]);

  const selectedPerformanceCycle = useMemo(
    () => performanceCycles?.find((item: any) => +item.id === +currentCycleValue),
    [currentCycleValue, performanceCycles],
  );
  const isTeamSelfEvaluationEnabled = selectedPerformanceCycle?.teamSelfEvaluation ?? false;

  useEffect(() => {
    const value = props.value;
    console.log(props.value);
    const value2: any[] = [];
    if (isSupervisor || user?.roles?.includes('admin') || user?.roles?.includes('hr')) {
      setMode('edit');
    } else if (!isSupervisor && (user?.userId == +params.oid || isLeader)) {
      if (
        value.approvalStatus === 'submitted' ||
        value.approvalStatus === 'approved' ||
        !value.goalsAvailability
      ) {
        setMode('view');
      } else {
        setMode('edit');
      }
    } else {
      setMode('view');
    }
    setApprovalStatus(value.approvalStatus);
    const weightList: Record<
      number,
      {
        weight: number;
        onHold: boolean;
      }
    > = {};
    const supervisorEvaluationList1: Record<number, { supervisorMark: number; weight: number }> =
      {};
    const selfEvaluationList1: Record<number, { selfUserMark: number; weight: number }> = {};

    // Single source of truth for weight selection: a personal/owner summary uses `weight`,
    // a team summary uses `teamWeight`. NaN/missing falls back to `fallback`.
    const isOwnerView = !!props.value.goalSummaryOwner;
    const pickWeight = (item: any, fallback = 1): number => {
      const n = +(isOwnerView ? item?.weight : item?.teamWeight);
      return isNaN(n) ? fallback : n;
    };

    for (const d of value?.goals) {
      weightList[d?.id] = {
        weight: pickWeight(d, 0),
        onHold: d.status === 'On-hold',
      };
      d.children = d?.keyResults
        ?.sort((a: any, b: any) => parseFloat(a.id) - parseFloat(b.id))
        .map((e: any) => ({
          ...e,
          owner: d.owner,
          treeType: 'KeyResult',
          goalHolder: d?.goalHolder,
          parent: {
            keyResultCount: d?.keyResults.length,
            id: d.id,
            maxWeight: Math.max(...d?.keyResults.map((x: any) => pickWeight(x))),
            totalWeight: d?.keyResults.reduce((x: number, y: any) => x + pickWeight(y), 0),
          },
          weight: pickWeight(e),
          key: 'k' + e.id,
        }));
      // delete d.keyResults;
      value2.push({
        ...d,
        completed:
          d.keyResults.reduce((x: number, y: any) => {
            const product = +y.completed * pickWeight(y);
            return x + (isNaN(product) ? 0 : product);
          }, 0) / d?.keyResults.reduce((x: number, y: any) => x + pickWeight(y), 0) ?? 0,
        treeType: 'Objective',
        key: 'o' + d.id,
        maxWeight: Math.max(...d?.keyResults.map((x: any) => pickWeight(x))),
        totalWeight: d?.keyResults.reduce((x: number, y: any) => x + pickWeight(y), 0),
      });
      if (d.userMark !== undefined && d.status !== 'On-hold') {
        selfEvaluationList1[d?.id] = {
          selfUserMark: d?.userMark,
          weight: pickWeight(d, 0),
        };
      }
      if (d.supervisorMark !== undefined && d.status !== 'On-hold') {
        supervisorEvaluationList1[d?.id] = {
          supervisorMark: d?.supervisorMark,
          weight: pickWeight(d, 0),
        };
      }
    }
    setSelfEvaluationList(selfEvaluationList1);
    setSupervisorEvaluationList(supervisorEvaluationList1);
    setGoalSummaryId(value.goalSummaryId);
    setWeightList(weightList);
    setMaxWeight(
      Math.max(0, ...Object.values(weightList).map((s) => (isNaN(s.weight) ? 0 : s.weight))),
    );
    setData(value2);
    // eslint-disable-next-line
  }, [isLeader, isSupervisor, fetching, props.value]);

  useEffect(() => {
    const supervisorList: number[] = [];
    let isMounted = true;
    // const commonGoalsList: number[] = [];
    if (currentCycleValue && props.value.teamId && props.value.teamId !== -1) {
      connection
        .get(
          `common/${params.type}/${params.oid ?? props.value.teamId}/${
            props.value.teamId
          }/${currentCycleValue}`,
        )
        .then((res: any) => {
          if (isMounted) {
            const leadersList: number[] = [];
            const directSupervisorList: number[] = [];
            for (const item of res?.response?.supervisors ?? []) {
              supervisorList.push(item.id);
            }
            for (const item of res?.response?.directSupervisors ??
              res?.response?.supervisors ??
              []) {
              directSupervisorList.push(item.id);
            }
            for (const item of res?.response?.leads ?? []) {
              leadersList.push(item.id);
            }
            setSupervisors(supervisorList);
            setDirectSupervisors(directSupervisorList);
            setCommonGoals(res?.response?.commonGoals ?? []);
            setSelectCommonObjective(
              res?.response?.commonGoals.length > 0 ? +res?.response?.commonGoals[0].id : 0,
            );
            if (user && user?.goalHolderId !== +params.id && supervisorList.includes(user.userId)) {
              setIsSupervisor(true);
              if (leadersList.includes(user.userId)) {
                setIsLeader(true);
              }
            } else if (user && leadersList.includes(user.userId)) {
              setIsLeader(true);
              setIsSupervisor(false);
            } else {
              setIsSupervisor(false);
            }
          }
        });
    } else if (currentCycleValue && props.value.teamId === -1) {
      connection
        .get(`common/${params.type}/${params.oid}/0/${currentCycleValue}`)
        .then((res: any) => {
          if (isMounted) {
            const leadersList: number[] = [];
            const directSupervisorList: number[] = [];
            for (const item of res?.response?.supervisors ?? []) {
              supervisorList.push(item.id);
            }
            for (const item of res?.response?.directSupervisors ??
              res?.response?.supervisors ??
              []) {
              directSupervisorList.push(item.id);
            }
            for (const item of res?.response?.leads ?? []) {
              leadersList.push(item.id);
            }
            setSupervisors(supervisorList);
            setDirectSupervisors(directSupervisorList);
            setCommonGoals(res?.response?.commonGoals ?? []);
            setSelectCommonObjective(
              res?.response?.commonGoals.length > 0 ? +res?.response?.commonGoals[0].id : 0,
            );
            if (user && user?.goalHolderId !== +params.id && supervisorList.includes(user.userId)) {
              setIsSupervisor(true);
              if (leadersList.includes(user.userId)) {
                setIsLeader(true);
              }
            } else if (user && leadersList.includes(user.userId)) {
              setIsLeader(true);
              setIsSupervisor(false);
            } else {
              setIsSupervisor(false);
            }
          }
        });
    }
    return () => {
      isMounted = false;
    };
  }, [connection, currentCycleValue, location, params, props.value, props.value.teamId, user]);

  useEffect(() => {
    const total = Object.values(weightList)
      .filter((e) => !e.onHold)
      .reduce((a, b) => +a + +b.weight, 0);
    setTotal(total);
    const totalSupVis = Object.values(supervisorEvaluationList)
      .filter((e) => e.supervisorMark)
      .reduce((pre, next) => pre + next.supervisorMark * +next.weight, 0);
    setTotalSupVis(totalSupVis);
    setIsSelfUserMarks(true);
    const totalSelfMarks = Object.values(selfEvaluationList)
      .filter((e) => e.selfUserMark)
      .reduce((pre, next) => pre + next.selfUserMark * +next.weight, 0);
    setTotalSelfUserMarks(totalSelfMarks);

    // if (total !== 100) {
    //   setError(true);
    // } else {
    //   setError(false);
    // }
  }, [weightList, supervisors, supervisorEvaluationList, selfEvaluationList]);

  useEffect(() => {
    setTotalSelfPercent(
      Math.round(
        ((isNaN(totalSelfUserMarks / total) ? 0 : totalSelfUserMarks / total) + Number.EPSILON) *
          100,
      ) / 100,
    );
    setTotalSupVisPercent(
      Math.round(((isNaN(totalSupVis / total) ? 0 : totalSupVis / total) + Number.EPSILON) * 100) /
        100,
    );
  }, [total, totalSelfUserMarks, totalSupVis]);

  const showApproveModal = useCallback(
    (x: string, y: string) => {
      const receiver: number[] = x === 'submitted' ? directSupervisors : [goalSummaryId];

      confirm({
        title: 'Submitting your records',
        icon: <ExclamationCircleOutlined />,
        content: `If you ${y} you won't be able to change`,
        okText: `${y}!`,
        centered: true,
        okType: 'primary',
        cancelText: 'Cancel',
        onOk() {
          connection
            .patch(`goals/goalSummary/${goalSummaryId}`, { state: x, receiver })
            .then(() => {
              setFetching(!fetching);
              props.reload();
            })
            .catch((e) => {
              setFetching(!fetching);
              console.error(e);
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [connection, directSupervisors, fetching, goalSummaryId, props.reload, user?.userId],
  );

  const createCommonObjective = useCallback(async () => {
    setLoading1(true);
    await connection
      .post(`goals/common`, { goalId: selectCommonObjective, goalSummeryId: goalSummaryId })
      .then(() => {
        setSelectCommonObjective(undefined);
        setFetching(!fetching);
        props.reload();
      })
      .catch((e) => {
        setFetching(!fetching);
        console.error(e);
      })
      .finally(() => {
        setLoading1(false);
        setCommonObjectiveVisible(false);
      });
  }, [connection, fetching, goalSummaryId, props, selectCommonObjective]);

  const showErrorModal = useCallback(() => {
    confirm({
      title: 'Error',
      icon: <CloseCircleOutlined />,
      content: objectiveError?.error,
      okText: 'Yes,Discard it!',
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [objectiveError?.error]);

  const columns = useMemo(() => {
    return props.value.goalSummaryOwner || isTeamSelfEvaluationEnabled
      ? [
          {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            sorter: (a: any, b: any) => a.title.length - b.title.length,
            // eslint-disable-next-line react/display-name
            render: (title: string, record: any) => {
              return {
                props: {
                  style: { display: 'flex' },
                },
                children: (
                  <Space size={15} style={{ display: 'flex', minHeight: 50 }}>
                    <Space size={15} style={{ display: 'flex', alignItems: 'center' }}>
                      {record?.goalHolder != params.id && (
                        <Tooltip
                          title={`This is ${props?.value?.teamName ?? 'a team'} ${
                            record.treeType
                          }`}>
                          <LinkOutlined />
                        </Tooltip>
                      )}
                      <div
                        style={
                          {
                            // maxWidth: record.treeType === 'Objective' ? 300 : 260,
                            // textOverflow: 'ellipsis',
                            // whiteSpace: 'nowrap',
                            // overflow: 'hidden',
                          }
                        }>
                        <Link
                          onClick={() => {
                            if (record.treeType === 'Objective') {
                              setQuery(
                                {
                                  goalId: record.id,
                                  cycle: currentCycleValue,
                                },
                                'replace',
                              );
                            } else {
                              setQuery(
                                {
                                  keyResultId: record.id,
                                  cycle: currentCycleValue,
                                },
                                'replace',
                              );
                              setKeyResultCount(record.parent.keyResultCount);
                            }
                          }}>
                          {title}
                        </Link>
                      </div>
                      {record?.parent !== null &&
                        record?.parent?.id !== undefined &&
                        record.treeType === 'Objective' && (
                          <Tooltip title={'Parent'}>
                            <LinkOutlined
                              onClick={() => {
                                history1.push(
                                  `/webux/parent-goal/${currentCycleValue}/${
                                    record?.parent.id
                                  }/${encodeURIComponent(record?.parent?.title ?? '')}/view`,
                                );
                              }}
                            />
                          </Tooltip>
                        )}
                    </Space>
                  </Space>
                ),
              };
            },
          },
          // {
          //   title: 'Type',
          //   dataIndex: 'type',
          //   key: 'type',
          //   width: '100px',
          //   // eslint-disable-next-line react/display-name
          //   render: (text: string, record: any) =>
          //     record.treeType === 'KeyResult' ? (
          //       <Tag color="cyan">{record.treeType}</Tag>
          //     ) : (
          //       <Tag color="purple">{record.treeType}</Tag>
          //     ),
          // },
          // {
          //   title: 'Owner',
          //   dataIndex: 'owner',
          //   key: 'owner',
          //   // width: '150px',
          //   // eslint-disable-next-line react/display-name
          //   render: (text: string, record: any) =>
          //     record.owner?.photo === '' || record?.photo === null ? (
          //       <UserAvatar size={'small'} />
          //     ) : (
          //       <UserAvatar src={record.owner?.photo} size={'small'} />
          //     ),
          // },
          {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            width: '180px',
            // eslint-disable-next-line react/display-name
            render: (text: string, record: any) =>
              record.treeType === 'Objective' ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}>
                  {mode === 'edit' && (
                    <WeightInput
                      setLoading={props.setLoading1}
                      value={weightList[record.id].weight}
                      onChange={(e) => {
                        setLoading(true);
                        const newList = { ...weightList };
                        newList[record.id] = {
                          weight: e,
                          onHold: record.status === 'On-hold',
                        };
                        if (record.status !== 'On-hold') {
                          const newSupervisorEvaluationList = { ...supervisorEvaluationList };
                          newSupervisorEvaluationList[record.id] = {
                            ...newSupervisorEvaluationList[record.id],
                            weight: e,
                          };
                          const newSelfEvaluationList = { ...selfEvaluationList };
                          newSelfEvaluationList[record.id] = {
                            ...newSelfEvaluationList[record.id],
                            weight: e,
                          };
                          setSelfEvaluationList(newSelfEvaluationList);
                          setSupervisorEvaluationList(newSupervisorEvaluationList);
                        }
                        setWeightList(newList);
                        setMaxWeight(Math.max(0, ...Object.values(newList).map((x) => x.weight)));
                        connection
                          .post(
                            `goals/${props.value.goalSummaryOwner ? 'weight' : 'team-weight'}/${
                              record.id
                            }`,
                            { weight: e },
                          )
                          .then(() => setLoading(false))
                          .catch((e1) => console.error(e1));
                      }}
                    />
                  )}
                  {mode === 'view' && (
                    <Typography style={{ paddingRight: '10px' }}>
                      {weightList[record.id].weight}
                    </Typography>
                  )}
                  <Progress
                    showInfo={false}
                    percent={
                      isNaN(weightList[record.id].weight) ||
                      (weightList?.[record.id].weight ?? 0) === 0 ||
                      (weightList?.[record.id].weight ?? 0) === null
                        ? 1
                        : 100
                    }
                    steps={
                      !isNaN(weightList[record.id].weight) &&
                      (weightList?.[record.id].weight ?? 0) !== 0 &&
                      (weightList?.[record.id].weight ?? 0) !== null
                        ? Math.round(
                            Math.round(
                              isNaN(weightList[record.id].weight / (maxWeight ?? 1))
                                ? 0
                                : ((weightList?.[record.id].weight ?? 0) / (maxWeight ?? 1)) * 100,
                            ) / 5,
                          )
                        : 1
                    }
                    size="small"
                    strokeColor={'green'}
                  />
                  {/*<Typography>{`${*/}
                  {/*  Math.round(*/}
                  {/*    (isNaN(weightList[record.id] / total) ? 0 : weightList[record.id] / total) **/}
                  {/*      10000,*/}
                  {/*  ) / 100*/}
                  {/*}% `}</Typography>*/}
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}>
                  {mode === 'edit' && (
                    <WeightInput
                      setLoading={props.setLoading1}
                      value={+record.weight}
                      onChange={(e) => {
                        setLoading(true);
                        const dataX = [...data];
                        const yy = [
                          ...dataX.map((w) => {
                            if (w.id === record.parent.id) {
                              return {
                                ...w,
                                children: w.children.map((k: any) => {
                                  if (k.id === record.id) {
                                    return { ...k, weight: +e };
                                  }
                                  return k;
                                }),
                                keyResults: w.keyResults.map((k: any) => {
                                  if (k.id === record.id) {
                                    return { ...k, weight: +e };
                                  }
                                  return k;
                                }),
                              };
                            }
                            return w;
                          }),
                        ];
                        setData([
                          ...yy.map((d) => ({
                            ...d,
                            completed:
                              d.children.reduce(
                                (x: number, y: any) => x + +y.completed * +y.weight,
                                0,
                              ) /
                              d?.children.reduce((x: number, y: any) => x + (+y?.weight ?? 1), 0),
                            maxWeight: Math.max(...d?.children.map((x: any) => x?.weight ?? 1)),
                            totalWeight: d?.children.reduce(
                              (x: number, y: any) => x + (+y?.weight ?? 1),
                              0,
                            ),
                            keyResults: [
                              ...d.children.map((n: any) => ({
                                ...n,
                                parent: {
                                  id: d.id,
                                  maxWeight: Math.max(
                                    ...d?.children.map((x: any) => x?.weight ?? 1),
                                  ),
                                  totalWeight: d?.children.reduce(
                                    (x: number, y: any) => x + (+y?.weight ?? 1),
                                    0,
                                  ),
                                },
                              })),
                            ],
                            children: [
                              ...d.children.map((n: any) => ({
                                ...n,
                                parent: {
                                  id: d.id,
                                  maxWeight: Math.max(
                                    ...d?.children.map((x: any) => x?.weight ?? 1),
                                  ),
                                  totalWeight: d?.children.reduce(
                                    (x: number, y: any) => x + (+y?.weight ?? 1),
                                    0,
                                  ),
                                },
                              })),
                            ],
                          })),
                        ]);
                        connection
                          .post(
                            `goals/${props.value.goalSummaryOwner ? 'weight' : 'team-weight'}/${
                              record.id
                            }`,
                            { weight: e },
                          )
                          .then(() => setLoading(false))
                          .catch((e1) => {
                            setData(dataX);
                            console.error(e1);
                          });
                      }}
                    />
                  )}
                  {mode === 'view' && (
                    <Typography style={{ paddingRight: '10px' }}>{+record.weight}</Typography>
                  )}
                  <Progress
                    showInfo={false}
                    percent={
                      isNaN(record.weight) ||
                      (record.weight ?? 0) === 0 ||
                      (record.weight ?? 0) === null
                        ? 1
                        : 100
                    }
                    steps={
                      !isNaN(record.weight) &&
                      (record?.weight ?? 0) !== 0 &&
                      (record?.weight ?? 0) !== null
                        ? Math.round(
                            Math.round(
                              isNaN(record?.weight / (record?.parent?.maxWeight ?? 1))
                                ? 0
                                : ((record?.weight ?? 0) / (record?.parent?.maxWeight ?? 1)) * 100,
                            ) / 5,
                          )
                        : 1
                    }
                    size="small"
                    strokeColor={'#faad14'}
                  />
                </div>
              ),
            // width: '150px',
          },
          {
            title: 'Progress',
            dataIndex: 'progress',
            key: 'progress',
            width: '180px',
            // eslint-disable-next-line react/display-name
            render: (text: string, record: any) =>
              record.treeType === 'KeyResult' ? (
                <Popover
                  destroyTooltipOnHide
                  onOpenChange={(e) => {
                    if (!e) {
                      setPopOverVisible('');
                    }
                  }}
                  content={
                    <KeyUpdateInput
                      id={record.id}
                      onCancel={() => {
                        setPopOverVisible('');
                        props.reload();
                      }}
                      value={record}
                    />
                  }
                  open={popOverVisible === record.key}
                  trigger="click">
                  <Card
                    style={{
                      border: 'transparent',
                      display: 'flex',
                      flexDirection: 'row',
                      cursor: 'pointer',
                      alignItems: 'center',
                    }}
                    bodyStyle={{ padding: 0, margin: 0, width: '90%' }}
                    onClick={() => {
                      setPopOverVisible(record.key);
                      setPopOverVisible1('');
                    }}>
                    <Progress
                      percent={+(+(record?.completed ?? 0)).toFixed(2)}
                      strokeColor={
                        record?.status === 'Completed'
                          ? 'green'
                          : record?.status === 'Offtrack'
                          ? 'red'
                          : record?.status === 'On-hold'
                          ? 'cyan'
                          : record?.status === 'Pending'
                          ? '#096dd9'
                          : record?.status === 'Ontrack'
                          ? '#f4d03f'
                          : '#000000'
                      }
                    />
                  </Card>
                </Popover>
              ) : (
                <Progress
                  style={{ width: '90%' }}
                  percent={+(+(record?.completed ?? 0)).toFixed(2)}
                  strokeColor={
                    record?.status === 'Completed'
                      ? 'green'
                      : record?.status === 'Offtrack'
                      ? 'red'
                      : record?.status === 'On-hold'
                      ? 'cyan'
                      : record?.status === 'Pending'
                      ? '#096dd9'
                      : record?.status === 'Ontrack'
                      ? '#f4d03f'
                      : '#000000'
                  }
                />
              ),
          },
          {
            title: 'Status',
            dataIndex: 'status',
            width: '100px',
            key: 'status',
            // eslint-disable-next-line react/display-name
            render: (text: string, record: any) =>
              record.treeType === 'KeyResult' ? (
                <Popover
                  destroyTooltipOnHide
                  onOpenChange={(e) => {
                    if (!e) {
                      setPopOverVisible1('');
                    }
                  }}
                  content={
                    <KeyUpdateInput
                      id={record.id}
                      onCancel={() => {
                        setPopOverVisible1('');
                        props.reload();
                      }}
                      value={record}
                    />
                  }
                  open={popOverVisible1 === record.key}
                  trigger="click">
                  <Card
                    style={{
                      border: 'transparent',
                      display: 'flex',
                      flexDirection: 'row',
                      cursor: 'pointer',
                      alignItems: 'center',
                    }}
                    bodyStyle={{ padding: 0, margin: 0, width: '100%' }}
                    onClick={() => {
                      setPopOverVisible1(record.key);
                      setPopOverVisible('');
                    }}>
                    {record.status == 'Pending' ? (
                      <Tag color="blue">Pending</Tag>
                    ) : record.status == 'Not Started' ? (
                      <Tag color="">Not Started</Tag>
                    ) : record.status == 'Ontrack' ? (
                      <Tag color="yellow">Ontrack</Tag>
                    ) : record.status == 'On-hold' ? (
                      <Tag color="cyan">On-hold</Tag>
                    ) : record.status == 'Offtrack' ? (
                      <Tag color="red">Offtrack</Tag>
                    ) : (
                      <Tag color="green">Completed</Tag>
                    )}
                  </Card>
                </Popover>
              ) : record.status == 'Pending' ? (
                <Tag color="blue" style={{ cursor: 'pointer' }}>
                  Pending
                </Tag>
              ) : record.status == 'Not Started' ? (
                <Tag color="" style={{ cursor: 'pointer' }}>
                  Not Started
                </Tag>
              ) : record.status == 'Ontrack' ? (
                <Tag color="yellow" style={{ cursor: 'pointer' }}>
                  Ontrack
                </Tag>
              ) : record.status == 'Offtrack' ? (
                <Tag color="red" style={{ cursor: 'pointer' }}>
                  Offtrack
                </Tag>
              ) : record.status == 'On-hold' ? (
                <Tag color="cyan" style={{ cursor: 'pointer' }}>
                  On-hold
                </Tag>
              ) : (
                <Tag color="green" style={{ cursor: 'pointer' }}>
                  Completed
                </Tag>
              ),
          },
          {
            title: 'Self Evaluation',
            dataIndex: 'userMark',
            key: 'userMark',
            width: '120px',
            // eslint-disable-next-line react/display-name
            render: (text: string | number, record: any) =>
              record.treeType !== 'KeyResult' ? (
                user?.userId !== props.value?.goalSummaryOwner && !isLeader ? (
                  <Typography>
                    {text === 'submitted' ? (
                      <Tag icon={<CheckOutlined />} color="green">
                        Submitted
                      </Tag>
                    ) : text || text === 0 ? (
                      <FlexBox direction={'horizontal'} horizontalAlign={'center'}>
                        <div>
                          {/*<Typography>{`${text} %`}</Typography>*/}
                          <MarksPopOver
                            setLoading={props.setLoading1}
                            value={{
                              value: record?.userMark,
                              comment: record?.userComment,
                            }}
                            goalId={record.id ?? 0}
                            goal={record?.title ?? ''}
                            type="user"
                            mode={'view'}
                            onSubmit={() => {
                              props.reload();
                            }}
                            disableSet={false}
                            objectiveType={params.type}
                          />
                        </div>
                      </FlexBox>
                    ) : (
                      <Tag icon={<ClockCircleOutlined />} color="blue">
                        Pending
                      </Tag>
                    )}
                  </Typography>
                ) : (
                  <MarksPopOver
                    setLoading={props.setLoading1}
                    value={{
                      value: record?.userMark,
                      comment: record?.userComment,
                    }}
                    goalId={record.id ?? 0}
                    goal={record?.title ?? ''}
                    type="user"
                    mode={record?.userMark && record?.supervisorMark ? 'view' : 'edit'}
                    onSubmit={() => {
                      props.reload();
                    }}
                    disableSet={
                      record?.status === 'Pending' ||
                      record?.keyResults?.find((n: any) => n?.status === 'Pending')
                    }
                    objectiveType={params.type}
                  />
                )
              ) : (
                <></>
              ),
          },
          {
            title: 'Supervisor Evaluation',
            dataIndex: 'supervisorMark',
            key: 'supervisorMark',
            width: '160px',
            // eslint-disable-next-line react/display-name
            render: (text: string | number, record: any) =>
              record.treeType !== 'KeyResult' ? (
                !(user?.userId !== props.value?.goalSummaryOwner && isSupervisor) ? (
                  <Typography>
                    {record?.supervisorMark === 'waiting' ? (
                      <Tag icon={<CheckOutlined />} color="green">
                        Completed
                      </Tag>
                    ) : text || text === 0 ? (
                      <MarksPopOver
                        setLoading={props.setLoading1}
                        value={{
                          value: record?.supervisorMark,
                          comment: record?.supervisorComment,
                        }}
                        goalId={record.id ?? 0}
                        goal={record?.title ?? ''}
                        type="supervisor"
                        onSubmit={() => {
                          props.reload();
                        }}
                        disableSet={false}
                        mode={'view'}
                        objectiveType={params.type}
                      />
                    ) : text === 'waiting' ? (
                      <Tag icon={<CheckOutlined />} color="green">
                        Completed
                      </Tag>
                    ) : (
                      <Tag icon={<ClockCircleOutlined />} color="blue">
                        Pending
                      </Tag>
                    )}
                  </Typography>
                ) : (
                  <MarksPopOver
                    setLoading={props.setLoading1}
                    value={{
                      value: record?.supervisorMark,
                      comment: record?.supervisorComment,
                    }}
                    goalId={record.id ?? 0}
                    goal={record?.title ?? ''}
                    type="supervisor"
                    onSubmit={() => {
                      props.reload();
                    }}
                    disableSet={false}
                    mode={'edit'}
                    objectiveType={params.type}
                  />
                )
              ) : (
                <></>
              ),
          },
        ]
      : [
          {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            sorter: (a: any, b: any) => a.title.length - b.title.length,
            // eslint-disable-next-line react/display-name
            render: (title: string, record: any) => {
              return {
                props: {
                  style: { display: 'flex' },
                },
                children: (
                  <Space size={15} style={{ display: 'flex', minHeight: 50 }}>
                    <Space size={15} style={{ display: 'flex', alignItems: 'center' }}>
                      {record?.goalHolder != params.id && (
                        <Tooltip
                          title={`This is ${props?.value?.teamName ?? 'a team'} ${
                            record.treeType
                          }`}>
                          <LinkOutlined />
                        </Tooltip>
                      )}
                      <div
                        style={
                          {
                            // maxWidth: record.treeType === 'Objective' ? 300 : 260,
                            // textOverflow: 'ellipsis',
                            // whiteSpace: 'nowrap',
                            // overflow: 'hidden',
                          }
                        }>
                        <Link
                          onClick={() =>
                            record.treeType === 'Objective'
                              ? setQuery(
                                  {
                                    goalId: record.id,
                                    cycle: currentCycleValue,
                                  },
                                  'replace',
                                )
                              : setQuery(
                                  {
                                    keyResultId: record.id,
                                    cycle: currentCycleValue,
                                  },
                                  'replace',
                                )
                          }>
                          {title}
                        </Link>
                      </div>
                      {record?.parent !== null &&
                        record?.parent?.id !== undefined &&
                        record.treeType === 'Objective' && (
                          <Tooltip title={'Parent'}>
                            <LinkOutlined
                              onClick={() => {
                                history1.push(
                                  `/webux/parent-goal/${currentCycleValue}/${
                                    record?.parent.id
                                  }/${encodeURIComponent(record?.parent?.title ?? '')}/view`,
                                );
                              }}
                            />
                          </Tooltip>
                        )}
                    </Space>
                  </Space>
                ),
              };
            },
          },
          // {
          //   title: 'Type',
          //   dataIndex: 'type',
          //   key: 'type',
          //   width: '100px',
          //   // eslint-disable-next-line react/display-name
          //   render: (text: string, record: any) =>
          //     record.treeType === 'KeyResult' ? (
          //       <Tag color="cyan">{record.treeType}</Tag>
          //     ) : (
          //       <Tag color="purple">{record.treeType}</Tag>
          //     ),
          // },
          // {
          //   title: 'Owner',
          //   dataIndex: 'owner',
          //   key: 'owner',
          //   // width: '150px',
          //   // eslint-disable-next-line react/display-name
          //   render: (text: string, record: any) =>
          //     record.owner?.photo === '' || record?.photo === null ? (
          //       <UserAvatar size={'small'} />
          //     ) : (
          //       <UserAvatar src={record.owner?.photo} size={'small'} />
          //     ),
          // },
          {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            width: '180px',
            // eslint-disable-next-line react/display-name
            render: (text: string, record: any) =>
              record.treeType === 'Objective' ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}>
                  {mode === 'edit' && (
                    <WeightInput
                      setLoading={props.setLoading1}
                      value={weightList[record.id].weight}
                      onChange={(e) => {
                        setLoading(true);
                        const newList = { ...weightList };
                        newList[record.id] = {
                          weight: e,
                          onHold: record.status === 'On-hold',
                        };
                        if (record.status !== 'On-hold') {
                          const newSupervisorEvaluationList = { ...supervisorEvaluationList };
                          newSupervisorEvaluationList[record.id] = {
                            ...newSupervisorEvaluationList[record.id],
                            weight: e,
                          };
                          const newSelfEvaluationList = { ...selfEvaluationList };
                          newSelfEvaluationList[record.id] = {
                            ...newSelfEvaluationList[record.id],
                            weight: e,
                          };
                          setSelfEvaluationList(newSelfEvaluationList);
                          setSupervisorEvaluationList(newSupervisorEvaluationList);
                        }
                        setWeightList(newList);
                        setMaxWeight(Math.max(0, ...Object.values(newList).map((x) => x.weight)));
                        connection
                          .post(
                            `goals/${props.value.goalSummaryOwner ? 'weight' : 'team-weight'}/${
                              record.id
                            }`,
                            { weight: e },
                          )
                          .then(() => setLoading(false))
                          .catch((e1) => console.error(e1));
                      }}
                    />
                  )}
                  {mode === 'view' && (
                    <Typography style={{ paddingRight: '10px' }}>
                      {weightList[record.id].weight}
                    </Typography>
                  )}
                  <Progress
                    showInfo={false}
                    percent={
                      isNaN(weightList[record.id].weight) ||
                      (weightList?.[record.id].weight ?? 0) === 0 ||
                      (weightList?.[record.id].weight ?? 0) === null
                        ? 1
                        : 100
                    }
                    steps={
                      !isNaN(weightList[record.id].weight) &&
                      (weightList?.[record.id].weight ?? 0) !== 0 &&
                      (weightList?.[record.id].weight ?? 0) !== null
                        ? Math.round(
                            Math.round(
                              isNaN(weightList[record.id].weight / (maxWeight ?? 1))
                                ? 0
                                : ((weightList?.[record.id]?.weight ?? 0) / (maxWeight ?? 1) ?? 1) *
                                    100,
                            ) / 5,
                          )
                        : 1
                    }
                    size="small"
                    strokeColor={'green'}
                  />
                  {/*<Typography>{`${*/}
                  {/*  Math.round(*/}
                  {/*    (isNaN(weightList[record.id] / total) ? 0 : weightList[record.id] / total) **/}
                  {/*      10000,*/}
                  {/*  ) / 100*/}
                  {/*}% `}</Typography>*/}
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}>
                  {mode === 'edit' && (
                    <WeightInput
                      setLoading={props.setLoading1}
                      value={+record.weight}
                      onChange={(e) => {
                        setLoading(true);
                        const dataX = [...data];
                        const yy = [
                          ...dataX.map((w) => {
                            if (w.id === record.parent.id) {
                              return {
                                ...w,
                                children: w.children.map((k: any) => {
                                  if (k.id === record.id) {
                                    return { ...k, weight: +e };
                                  }
                                  return k;
                                }),
                                keyResults: w.keyResults.map((k: any) => {
                                  if (k.id === record.id) {
                                    return { ...k, weight: +e };
                                  }
                                  return k;
                                }),
                              };
                            }
                            return w;
                          }),
                        ];
                        console.log(yy);
                        setData([
                          ...yy.map((d) => ({
                            ...d,
                            maxWeight: Math.max(...d?.children.map((x: any) => x?.weight ?? 1)),
                            totalWeight: d?.children.reduce(
                              (x: number, y: any) => x + (+y?.weight ?? 1),
                              0,
                            ),
                            keyResults: [
                              ...d.children.map((n: any) => ({
                                ...n,
                                parent: {
                                  id: d.id,
                                  maxWeight: Math.max(
                                    ...d?.children.map((x: any) => x?.weight ?? 1),
                                  ),
                                  totalWeight: d?.children.reduce(
                                    (x: number, y: any) => x + (+y?.weight ?? 1),
                                    0,
                                  ),
                                },
                              })),
                            ],
                            children: [
                              ...d.children.map((n: any) => ({
                                ...n,
                                parent: {
                                  id: d.id,
                                  maxWeight: Math.max(
                                    ...d?.children.map((x: any) => x?.weight ?? 1),
                                  ),
                                  totalWeight: d?.children.reduce(
                                    (x: number, y: any) => x + (+y?.weight ?? 1),
                                    0,
                                  ),
                                },
                              })),
                            ],
                          })),
                        ]);
                        connection
                          .post(
                            `goals/${props.value.goalSummaryOwner ? 'weight' : 'team-weight'}/${
                              record.id
                            }`,
                            { weight: e },
                          )
                          .then(() => setLoading(false))
                          .catch((e1) => {
                            setData(dataX);
                            console.error(e1);
                          });
                      }}
                    />
                  )}
                  {mode === 'view' && (
                    <Typography style={{ paddingRight: '10px' }}>{+record.weight}</Typography>
                  )}
                  <Progress
                    showInfo={false}
                    percent={
                      isNaN(record.weight) ||
                      (record.weight ?? 0) === 0 ||
                      (record.weight ?? 0) === null
                        ? 1
                        : 100
                    }
                    steps={
                      !isNaN(record.weight) &&
                      (record?.weight ?? 0) !== 0 &&
                      (record?.weight ?? 0) !== null
                        ? Math.round(
                            Math.round(
                              isNaN(record?.weight / (record?.parent?.maxWeight ?? 1))
                                ? 0
                                : ((record?.weight ?? 0) / (record?.parent?.maxWeight ?? 1)) * 100,
                            ) / 5,
                          )
                        : 1
                    }
                    size="small"
                    strokeColor={'#faad14'}
                  />
                </div>
              ),
            // width: '150px',
          },
          {
            title: 'Progress',
            dataIndex: 'completed',
            key: 'completed',
            width: '180px',
            // eslint-disable-next-line react/display-name
            render: (text: string, record: any) =>
              record.treeType === 'KeyResult' ? (
                <Popover
                  destroyTooltipOnHide
                  onOpenChange={(e) => {
                    if (!e) {
                      setPopOverVisible2('');
                    }
                  }}
                  content={
                    <KeyUpdateInput
                      id={record.id}
                      onCancel={() => {
                        setPopOverVisible2('');
                        props.reload();
                      }}
                      value={record}
                    />
                  }
                  open={popOverVisible2 === record.key}
                  trigger="click">
                  <Card
                    style={{
                      border: 'transparent',
                      display: 'flex',
                      flexDirection: 'row',
                      cursor: 'pointer',
                      alignItems: 'center',
                    }}
                    bodyStyle={{ padding: 0, margin: 0, width: '90%' }}
                    onClick={() => {
                      setPopOverVisible2(record.key);
                      setPopOverVisible3('');
                    }}>
                    <Progress
                      percent={+(+(record?.completed ?? 0)).toFixed(2)}
                      strokeColor={
                        record?.status === 'Completed'
                          ? 'green'
                          : record?.status === 'Offtrack'
                          ? 'red'
                          : record?.status === 'On-hold'
                          ? 'cyan'
                          : record?.status === 'Pending'
                          ? '#096dd9'
                          : record?.status === 'Ontrack'
                          ? '#f4d03f'
                          : '#000000'
                      }
                    />
                  </Card>
                </Popover>
              ) : (
                <Progress
                  style={{ width: '90%' }}
                  percent={+(+(record?.completed ?? 0)).toFixed(2)}
                  strokeColor={
                    record?.status === 'Completed'
                      ? 'green'
                      : record?.status === 'Offtrack'
                      ? 'red'
                      : record?.status === 'On-hold'
                      ? 'cyan'
                      : record?.status === 'Pending'
                      ? '#096dd9'
                      : record?.status === 'Ontrack'
                      ? '#f4d03f'
                      : '#000000'
                  }
                />
              ),
          },
          {
            title: 'Status',
            dataIndex: 'status',
            width: '100px',
            key: 'status',
            // eslint-disable-next-line react/display-name
            render: (text: string, record: any) =>
              record.treeType === 'KeyResult' ? (
                <Popover
                  destroyTooltipOnHide
                  onOpenChange={(e) => {
                    if (!e) {
                      setPopOverVisible3('');
                    }
                  }}
                  content={
                    <KeyUpdateInput
                      id={record.id}
                      onCancel={() => {
                        setPopOverVisible3('');
                        props.reload();
                      }}
                      value={record}
                    />
                  }
                  open={popOverVisible3 === record.key}
                  trigger="click">
                  <Card
                    style={{
                      border: 'transparent',
                      display: 'flex',
                      flexDirection: 'row',
                      cursor: 'pointer',
                      alignItems: 'center',
                    }}
                    bodyStyle={{ padding: 0, margin: 0, width: '100%' }}
                    onClick={() => {
                      setPopOverVisible3(record.key);
                      setPopOverVisible2('');
                    }}>
                    {record.status == 'Pending' ? (
                      <Tag color="blue" style={{ cursor: 'default' }}>
                        Pending
                      </Tag>
                    ) : record.status == 'Not Started' ? (
                      <Tag color="" style={{ cursor: 'default' }}>
                        Not Started
                      </Tag>
                    ) : record.status == 'Ontrack' ? (
                      <Tag color="yellow" style={{ cursor: 'default' }}>
                        Ontrack
                      </Tag>
                    ) : record.status == 'On-hold' ? (
                      <Tag color="cyan" style={{ cursor: 'default' }}>
                        On-hold
                      </Tag>
                    ) : record.status == 'Offtrack' ? (
                      <Tag color="red" style={{ cursor: 'default' }}>
                        Offtrack
                      </Tag>
                    ) : (
                      <Tag color="green" style={{ cursor: 'default' }}>
                        Completed
                      </Tag>
                    )}
                  </Card>
                </Popover>
              ) : record.status == 'Pending' ? (
                <Tag color="blue" style={{ cursor: 'pointer' }}>
                  Pending
                </Tag>
              ) : record.status == 'Not Started' ? (
                <Tag color="" style={{ cursor: 'pointer' }}>
                  Not Started
                </Tag>
              ) : record.status == 'Ontrack' ? (
                <Tag color="yellow" style={{ cursor: 'pointer' }}>
                  Ontrack
                </Tag>
              ) : record.status == 'On-hold' ? (
                <Tag color="cyan" style={{ cursor: 'pointer' }}>
                  On-hold
                </Tag>
              ) : record.status == 'Offtrack' ? (
                <Tag color="red" style={{ cursor: 'pointer' }}>
                  Offtrack
                </Tag>
              ) : (
                <Tag color="green" style={{ cursor: 'pointer' }}>
                  Completed
                </Tag>
              ),
          },
          {
            title: 'Supervisor Evaluation',
            dataIndex: 'supervisorMark',
            key: 'supervisorMark',
            width: '160px',
            // eslint-disable-next-line react/display-name
            render: (text: string | number, record: any) =>
              record.treeType !== 'KeyResult' ? (
                !(user?.userId !== props.value?.goalSummaryOwner && isSupervisor) ? (
                  <Typography>
                    {record?.supervisorMark === 'waiting' ? (
                      <Tag icon={<CheckOutlined />} color="green">
                        Completed
                      </Tag>
                    ) : text || text === 0 ? (
                      <MarksPopOver
                        setLoading={props.setLoading1}
                        value={{
                          value: record?.supervisorMark,
                          comment: record?.supervisorComment,
                        }}
                        goalId={record.id ?? 0}
                        goal={record?.title ?? ''}
                        type="supervisor"
                        onSubmit={() => {
                          props.reload();
                        }}
                        mode={'view'}
                        disableSet={false}
                        objectiveType={params.type}
                      />
                    ) : (
                      <Tag icon={<ClockCircleOutlined />} color="blue">
                        Pending
                      </Tag>
                    )}
                  </Typography>
                ) : (
                  <MarksPopOver
                    setLoading={props.setLoading1}
                    value={{
                      value: record?.supervisorMark,
                      comment: record?.supervisorComment,
                    }}
                    goalId={record.id ?? 0}
                    goal={record?.title ?? ''}
                    type="supervisor"
                    onSubmit={() => {
                      props.reload();
                    }}
                    mode={'edit'}
                    disableSet={
                      record?.status === 'Pending' ||
                      record?.keyResults?.find((n: any) => n?.status === 'Pending')
                    }
                    objectiveType={params.type}
                  />
                )
              ) : (
                <></>
              ),
          },
        ];
    // eslint-disable-next-line
  }, [
    popOverVisible1,
    popOverVisible2,
    popOverVisible3,
    popOverVisible,
    connection,
    fetching,
    currentCycleValue,
    history1,
    isTeamSelfEvaluationEnabled,
    isSupervisor,
    mode,
    data,
    params.type,
    props.value?.goalSummaryOwner,
    setQuery,
    props.reload,
    total,
    user?.userId,
    weightList,
  ]);

  return (
    <>
      <Space direction={'vertical'} style={{ width: '100%' }} size={16}>
        <Spin spinning={loading}>
          {/*<FlexBox direction="horizontal" horizontalAlign="left">*/}
          {/*  /!*{(props.value.goalSummaryOwner || isTeamSelfEvaluationEnabled) && (*!/*/}
          {/*  /!*  <div style={{ paddingRight: '20px' }}>*!/*/}
          {/*  /!*    <Text style={{ paddingRight: '20px' }} strong>*!/*/}
          {/*  /!*      Self Evaluation*!/*/}
          {/*  /!*    </Text>*!/*/}
          {/*  /!*    <Progress*!/*/}
          {/*  /!*      type="circle"*!/*/}
          {/*  /!*      percent={totalSelfPercent}*!/*/}
          {/*  /!*      width={100}*!/*/}
          {/*  /!*      format={() => `${totalSelfPercent}%`}*!/*/}
          {/*  /!*    />*!/*/}
          {/*  /!*  </div>*!/*/}
          {/*  /!*)}*!/*/}
          {/*  /!*<div>*!/*/}
          {/*  /!*  <Text style={{ paddingRight: '20px' }} strong>*!/*/}
          {/*  /!*    Supervision Evaluation*!/*/}
          {/*  /!*  </Text>*!/*/}
          {/*  /!*  <Progress*!/*/}
          {/*  /!*    type="circle"*!/*/}
          {/*  /!*    percent={totalSupVisPercent}*!/*/}
          {/*  /!*    width={100}*!/*/}
          {/*  /!*    format={() => `${totalSupVisPercent}%`}*!/*/}
          {/*  /!*  />*!/*/}
          {/*  /!*</div>*!/*/}
          {/*  /!*<div>*!/*/}
          {/*  /!*  <FlexBox direction="horizontal" horizontalAlign="left">*!/*/}
          {/*  /!*    <Text style={{ padding: '30px' }} strong>*!/*/}
          {/*  /!*      Supervisor Feedback <br />*!/*/}
          {/*  /!*      of Final Score*!/*/}
          {/*  /!*    </Text>*!/*/}
          {/*  /!*    <Progress type="circle" percent={totalSupVisPercent} width={100} />*!/*/}
          {/*  /!*  </FlexBox>*!/*/}
          {/*  /!*</div>*!/*/}

          {/*  /!*(((totalSupVisPercent * configration.per ) / 100 ) * cyclePer /100 ) /*!/*/}
          {/*</FlexBox>*/}
          <Divider style={{ marginTop: 5, marginBottom: 10 }} />
          <FlexBox
            direction="horizontal"
            style={{ alignItems: 'center', marginBottom: 15 }}
            horizontalAlign="left">
            <div style={{ flex: 1 }}>
              <Checkbox
                checked={expanded}
                onChange={() => {
                  setExpanded(!expanded);
                  if (!expanded) {
                    setExpandedRow(data.map((e) => e.key));
                  } else {
                    setExpandedRow([]);
                  }
                }}>
                Expand All
              </Checkbox>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
              <Title style={{ marginBottom: 0, marginRight: 20 }} level={5}>
                OKR Status
              </Title>
              {approvalStatus === 'submitted' ? (
                <Tooltip title={'Approval pending from supervisor'}>
                  <Tag style={{ height: 25 }} color="yellow">
                    Submitted for approval
                  </Tag>
                </Tooltip>
              ) : approvalStatus == 'approved' ? (
                <Tooltip title={'Objectives are ready for monitoring'}>
                  <Tag style={{ height: 25 }} color="green">
                    Approved
                  </Tag>
                </Tooltip>
              ) : approvalStatus == 'declined' ? (
                <Tooltip title={'Corrections pending'}>
                  <Tag style={{ height: 25 }} color="red">
                    Declined
                  </Tag>
                </Tooltip>
              ) : (
                <Tooltip title={'Submission pending'}>
                  <Tag style={{ height: 25 }} color="">
                    Draft
                  </Tag>
                </Tooltip>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Space>
                {/*{mode +*/}
                {/*  ' ' +*/}
                {/*  isSupervisor +*/}
                {/*  ' ' +*/}
                {/*  (params?.type !== 'team') +*/}
                {/*  ' ' +*/}
                {/*  isLeader +*/}
                {/*  ' ' +*/}
                {/*  approvalStatus +*/}
                {/*  ' ' +*/}
                {/*  commonGoals.length}*/}
                {mode === 'edit' && (
                  <>
                    {isSupervisor || (params?.type !== 'team' && isLeader) ? (
                      approvalStatus === 'submitted' ||
                      approvalStatus === 'approved' ||
                      approvalStatus === 'declined' ? (
                        <>
                          {data?.length !== 0 && (
                            <>
                              {approvalStatus !== 'declined' && approvalStatus !== 'approved' && (
                                <Button
                                  onClick={() => showApproveModal('declined', 'decline')}
                                  color={'danger'}>
                                  <ToTopOutlined style={{ fontSize: '100%' }} />
                                  Decline
                                </Button>
                              )}
                              {approvalStatus !== 'declined' && approvalStatus === 'approved' && (
                                <Button
                                  onClick={() => showApproveModal('declined', 'decline')}
                                  color={'warning'}>
                                  <ToTopOutlined style={{ fontSize: '100%' }} />
                                  Request for Resubmission
                                </Button>
                              )}
                              {approvalStatus !== 'approved' && (
                                <Button onClick={() => showApproveModal('approved', 'approve')}>
                                  <ToTopOutlined style={{ fontSize: '100%' }} />
                                  Approve
                                </Button>
                              )}
                            </>
                          )}
                          {commonGoals.length > 0 && (
                            <Button type="default" onClick={() => setCommonObjectiveVisible(true)}>
                              <PlusOutlined style={{ fontSize: '100%' }} /> Common Objective
                            </Button>
                          )}
                          <Button
                            type="primary"
                            onClick={() =>
                              setQuery(
                                {
                                  newGoal: 'new',
                                  cycle: currentCycleValue,
                                },
                                'replace',
                              )
                            }>
                            <PlusOutlined style={{ fontSize: '100%', color: 'white' }} /> New
                            Objective
                          </Button>
                        </>
                      ) : (
                        <>
                          {commonGoals.length > 0 && (
                            <Button type="default" onClick={() => setCommonObjectiveVisible(true)}>
                              <PlusOutlined style={{ fontSize: '100%' }} /> Common Objective
                            </Button>
                          )}
                          {(user?.userId == +params.oid ||
                            (params?.type === 'team' && isLeader)) && (
                            <Button onClick={() => showApproveModal('submitted', 'submit')}>
                              <ToTopOutlined style={{ fontSize: '100%' }} />
                              Submit
                            </Button>
                          )}
                          <Button
                            type="primary"
                            onClick={() =>
                              setQuery(
                                {
                                  newGoal: 'new',
                                  cycle: currentCycleValue,
                                },
                                'replace',
                              )
                            }>
                            <PlusOutlined style={{ fontSize: '100%', color: 'white' }} /> New
                            Objective
                          </Button>
                        </>
                      )
                    ) : user?.userId == +params.oid || (params?.type === 'team' && isLeader) ? (
                      <>
                        {data?.length !== 0 && (
                          <Button onClick={() => showApproveModal('submitted', 'submit')}>
                            <ToTopOutlined style={{ fontSize: '100%' }} />
                            Submit
                          </Button>
                        )}
                        <Button
                          type="primary"
                          onClick={() =>
                            setQuery(
                              {
                                newGoal: 'new',
                                cycle: currentCycleValue,
                              },
                              'replace',
                            )
                          }>
                          <PlusOutlined style={{ fontSize: '100%', color: 'white' }} /> New
                          Objective
                        </Button>
                      </>
                    ) : user?.roles?.includes('admin') || user?.roles?.includes('hr') ? (
                      <>
                        {commonGoals.length > 0 && (
                          <Button type="default" onClick={() => setCommonObjectiveVisible(true)}>
                            <PlusOutlined style={{ fontSize: '100%' }} /> Common Objective
                          </Button>
                        )}
                        <Button
                          type="primary"
                          onClick={() =>
                            setQuery(
                              {
                                newGoal: 'new',
                                cycle: currentCycleValue,
                              },
                              'replace',
                            )
                          }>
                          <PlusOutlined style={{ fontSize: '100%', color: 'white' }} /> New
                          Objective
                        </Button>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </Space>
            </div>
          </FlexBox>
          <QueryParams config={queryConfig}>
            {({ query }) => {
              return (
                <Table
                  rowClassName={(record) =>
                    record.key === `o${query.parent}` && query.parent ? 'data-row' : ''
                  }
                  columns={columns}
                  dataSource={data}
                  indentSize={70}
                  pagination={false}
                  size={'small'}
                  expandedRowKeys={expandedRow}
                  expandable={{
                    expandIcon: ({ expanded, onExpand, record }) =>
                      record?.children?.length > 0 &&
                      record?.children &&
                      (expanded ? (
                        <span style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
                          <CaretDownOutlined
                            onClick={(e: any) => {
                              if (expandedRow.includes(record.key)) {
                                setExpandedRow(expandedRow.filter((n) => n !== record.key));
                              }
                              setExpanded(false);
                              onExpand(record, e);
                            }}
                          />
                        </span>
                      ) : (
                        <span style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
                          <CaretRightOutlined
                            onClick={(e: any) => {
                              if (!expandedRow.includes(record.key)) {
                                setExpandedRow([...expandedRow, record.key]);
                              }
                              onExpand(record, e);
                            }}
                          />
                        </span>
                      )),
                  }}
                  summary={() => {
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={4} index={1} />
                          {isSelfUserMarks &&
                            (props.value.goalSummaryOwner || isTeamSelfEvaluationEnabled) && (
                              <Table.Summary.Cell colSpan={1} index={2}>
                                <div style={{ paddingRight: '20px' }}>
                                  <Progress percent={+totalSelfPercent} />
                                </div>
                              </Table.Summary.Cell>
                            )}
                          <Table.Summary.Cell colSpan={1} index={2}>
                            <div style={{ padding: '10px' }}>
                              <Progress percent={+totalSupVisPercent} />
                            </div>
                          </Table.Summary.Cell>
                          {/*<Table.Summary.Cell index={3} colSpan={2}>*/}
                          {/*  Total*/}
                          {/*</Table.Summary.Cell>*/}
                          {/*<Table.Summary.Cell index={4}>*/}
                          {/*  <div*/}
                          {/*    style={{*/}
                          {/*      width: '50%',*/}
                          {/*      display: 'flex',*/}
                          {/*      justifyContent: 'flex-start',*/}
                          {/*    }}>*/}
                          {/*    <Typography>{total}</Typography>*/}
                          {/*  </div>*/}
                          {/*</Table.Summary.Cell>*/}
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                />
              );
            }}
          </QueryParams>
        </Spin>
      </Space>
      <Modal
        open={!!query?.goalId && focus}
        maskClosable={false}
        onCancel={() => {
          if (objectiveError?.isError) {
            showErrorModal();
          } else {
            setQuery(
              {
                goalId: undefined,
                cycle: currentCycleValue,
              },
              'replace',
            );
          }
        }}
        footer={null}
        destroyOnClose={true}>
        {query?.goalId && (
          <Objective
            teamId={props.value.teamId}
            id={query?.goalId}
            mode={mode}
            isLeader={isLeader}
            goalSummaryOwner={props.value?.goalSummaryOwner}
            performanceCycle={performanceCycles?.find((e) => +e.id === +currentCycleValue)}
            setError={(error, isError) => {
              setObjectiveError({ error, isError });
            }}
            setClose={() =>
              setQuery(
                {
                  goalId: undefined,
                  cycle: currentCycleValue,
                },
                'replace',
              )
            }
          />
        )}
      </Modal>
      <Modal
        title={'Create objective from common objective'}
        open={commonObjectiveVisible && focus && commonGoals.length > 0}
        onCancel={() => setCommonObjectiveVisible(false)}
        destroyOnClose={true}
        okText={'Create objective'}
        okButtonProps={{
          loading: loading1,
        }}
        onOk={() => createCommonObjective()}>
        <>
          <FlexBox direction={'vertical'}>
            <Text>Common objective</Text>
            <Select
              defaultValue={commonGoals.length > 0 ? commonGoals[0].name : ''}
              style={{ width: '100%', marginTop: 10 }}
              onChange={(e) => setSelectCommonObjective(+e)}>
              {commonGoals.length > 0 &&
                commonGoals.map((goal) => (
                  <Option key={goal.id} value={goal.id}>
                    {goal.name}
                  </Option>
                ))}
            </Select>
          </FlexBox>
        </>
      </Modal>
      <Modal
        open={!!query?.keyResultId && focus}
        maskClosable={false}
        onCancel={() =>
          setQuery(
            {
              keyResultId: undefined,
              cycle: currentCycleValue,
            },
            'replace',
          )
        }
        footer={null}
        destroyOnClose={true}>
        {query?.keyResultId && (
          <KeyResult
            keyResultCount={keyResultCount}
            id={query?.keyResultId}
            setClose={() =>
              setQuery(
                {
                  keyResultId: undefined,
                  cycle: currentCycleValue,
                },
                'replace',
              )
            }
            mode={mode}
          />
        )}
      </Modal>
      {query?.newGoal && (
        <Modal
          open={!!query?.newGoal && focus}
          maskClosable={false}
          onCancel={() => {
            const answer = window.confirm(
              'Data will be lost if you close the modal, are you sure??',
            );
            if (answer) {
              setQuery(
                {
                  newGoal: undefined,
                  cycle: currentCycleValue,
                },
                'replace',
              );
            }
          }}
          footer={null}
          destroyOnClose={true}>
          <Objective
            new={true}
            teamId={props.value.teamId}
            mode={mode}
            isLeader={isLeader}
            goalSummaryId={props.value.goalSummaryId}
            performanceCycle={performanceCycles?.find((e) => +e.id === +currentCycleValue)}
            duration={[
              performanceCycles?.find((e) => +e.id === +currentCycleValue)?.startDate,
              performanceCycles?.find((e) => +e.id === +currentCycleValue)?.endDate,
            ]}
            setClose={() => {
              setQuery(
                {
                  newGoal: undefined,
                  cycle: currentCycleValue,
                },
                'replace',
              );
            }}
          />
        </Modal>
      )}
    </>
  );
};
